/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from 'react';
import { UsersListComp, Header } from '../components';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';
import { useTheme } from '../../../providers/theme';

import { Paginate } from '@vlinder-web/paginate-widget-react';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { vappContainer, VApplication } from '../../../application';
import { SettingsComp } from '../components/Settings';
import toast from 'react-hot-toast';
import { SearchFilter } from '../../../widgets/filter-widget-react';
import { DraftAppPageService } from '../services';
import {
  useSMDraftApplicationsPageGetContent,
  useSMDeleteDraft,
} from '../machines';
import { useNavigate } from 'react-router-dom';
import RouteConfig from '@/AppNavigator/services/config/routes.config.json';
import { AppNavigatorService } from '@/AppNavigator';
import { USER_LEVEL } from '@/config/userManagement.config';
import { Loader } from '@/components';
import { StorageModule } from '@vlinder-web/storage-module-react';

const getSrv = () => {
  return vappContainer.get<DraftAppPageService>(
    DraftAppPageService.displayName
  );
};

const getAppSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export const ContainerComm = (props: any) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [refreshPagination, setReFreshPagination] = useState(new Date());
  const staticPageContentConfig = getSrv()?.agent?.getStaticPageContentSync({});
  const [whoAmI, setWhoAmI] = useState('');
  const appSrv = getAppSrv();
  const storageSrv = StorageModule?.getInstance();
  const userProfile = storageSrv.get('myProfile', 'session');
  const role = userProfile?.org?.orgRole;
  const vuid = userProfile?.vuid;
  // const formDataConfig = getSrv()?.agent.getFormData();
  const [roe, setRoe] = useState(false);
  useEffect(() => {
    if (role === 'CARICOM_BUSSINESS_ORG') setRoe(true);
  }, [role]);
  const { getDraftApplicationsPageSend, getDraftApplicationsPageState } =
    useSMDraftApplicationsPageGetContent({});

  const { deleteDraftSend, deleteDraftMachine, deleteDraftState } =
    useSMDeleteDraft({});

  const _onHeaderDDActionItemClick = (id: string) => {};
  const onAddUser = (id: string) => {
    if (!showModal) {
      setShowModal(true);
    }
  };

  useEffect(() => {
    getWhoamI();
  }, []);
  const _onViewClick = (id: string, data: any) => {
    console.log(`_onViewClick`, id, data);
    navigate(`${RouteConfig?.routes?.Application?.path}?id=${id}`);
  };

  const onHeaderAction2Click = (id: string) => {
    if (id) {
      switch (id) {
        case 'import_users':
          toast.success('Coming soon!');
          // history.push(
          //   `${routesConfig?.routes?.UsersBatch?.path}`
          // );
          break;
        default:
          console.log(`unsupported header button id ${id} clicked`);
      }
    }
  };

  const onRefresh = () => {
    getDraftApplicationsPageSend('TRIGGER_REFRESH', {});
    setReFreshPagination(new Date());
  };

  const onClearFilter = () => {
    Array.from(document.querySelectorAll('input')).forEach(
      (input) => (input.value = '')
    );
    getDraftApplicationsPageSend('TRIGGER_REFRESH', {});
  };

  const onApplyFilter = (data: any, status: any) => {
    console.log(`on apply filter`, data);
    let criteria: any = [];
    if (data?.applicationNo) {
      criteria = [
        {
          column: 'applicationNo',
          op: 'Equal',
          value: data?.applicationNo,
        },
      ];
    }
    if (status) {
      criteria = [
        ...criteria,
        {
          column: 'status',
          op: 'Equal',
          value: status,
        },
      ];
    }

    getDraftApplicationsPageSend('TRIGGER_REFRESH', {
      where: criteria,
    });
  };
  console.log('contwhoam', whoAmI);
  const getWhoamI = async () => {
    const { whoami } = await appSrv.whoAmI();
    setWhoAmI(whoami);
  };

  const onTogglePress = (key: string, id: string) => {
    console.log('tott', key, id);
    if (key === 'delete') {
      deleteDraftSend('START', {
        payload: id,
      });
    }
    // if (key === 're-invite') {
    //   console.log('reinvite id', id);
    //   reInviteUserSend('START', {
    //     payload: id,
    //   });
    // }
    // if (key === 'activate') {
    //   activateUserSend('START', {
    //     payload: id,
    //   });
    // }
  };

  const _renderPage = () => {
    if (deleteDraftState?.matches('DELETE_USER')) {
      return (
        <Loader {...(staticPageContentConfig?.loading?.deleteDraft || {})} />
      );
    }
    if (
      getDraftApplicationsPageState?.matches('RENDER_PAGE') &&
      getDraftApplicationsPageState?.event?.data?.value
    ) {
      console.log(
        `getDraftApplicationsPageState :`,
        getDraftApplicationsPageState?.event?.data?.value,
        staticPageContentConfig
      );
      return (
        <>
          {getDraftApplicationsPageState?.event?.data?.value?.isEmpty ? (
            <StateOSD
              {...(staticPageContentConfig?.loading?.usersEmpty || {})}
            />
          ) : (
            <UsersListComp
              {...getDraftApplicationsPageState?.event?.data?.value}
              // {...(getDraftApplicationsPageState?.event?.data?.value || {})}
              onViewClick={_onViewClick}
              // onRowClick={props?.onViewDetailClick}
              // onRowClick={_onViewClick}
              whoAmI={whoAmI}
              onTogglePress={onTogglePress}
            />
          )}
        </>
      );
    }
    if (getDraftApplicationsPageState?.matches('GET_PAGE_CONTENT')) {
      return (
        <Loader {...(staticPageContentConfig?.loading?.loadingUsers || {})} />
      );
    }
    return <></>;
  };

  const _renderHeader = () => {
    if (staticPageContentConfig?.header) {
      return (
        <>
          <Header
            {...(staticPageContentConfig?.header || {})}
            onHeaderAction1Click={onAddUser}
            onHeaderDDActionItemClick={_onHeaderDDActionItemClick}
            onHeaderAction2Click={onHeaderAction2Click}
            onRefreshClick={onRefresh}
          />
          {/* <SearchFilter
            {...(staticPageContentConfig?.settings || {})}
            onFilterApply={onApplyFilter}
            onClearFilter={onClearFilter}
          /> */}
          <SettingsComp
            {...(USER_LEVEL.owner.includes(whoAmI ?? '')
              ? staticPageContentConfig?.settings || {}
              : {})}
            onApplyFilter={onApplyFilter}
            onClearFilter={onClearFilter}
          />
        </>
      );
    }
    return null;
  };

  const onPaginationChange = (event: any) => {
    getDraftApplicationsPageSend('TRIGGER_REFRESH', {
      offset: event?.selected * 10,
      size: 10,
    });
  };

  const _renderPagination = () => {
    if (!getDraftApplicationsPageState?.event?.data?.value?.isEmpty) {
      return (
        <Paginate
          {...(getDraftApplicationsPageState?.event?.data?.value || {})}
          onPageChange={onPaginationChange}
          key={refreshPagination}
          totalItems={
            getDraftApplicationsPageState?.event?.data?.value?.ultUsers?.length
          }
        />
      );
    }
  };

  const _renderErrorModals = () => {
    if (getDraftApplicationsPageState?.matches('RENDER_PAGE_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.getApplications || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (deleteDraftState?.matches('DELETE_USER_FAILED')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.deleteDraft || {})}
          description={[
            deleteDraftState?.event?.data?.value,
            staticPageContentConfig?.error?.deleteDraft?.description[1],
          ]}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
  };

  const _renderNotifications = () => {
    if (deleteDraftState?.matches('DELETE_USER_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.deleteDraftSuccess ||
            {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }

    return null;
  };

  const _sessionData = storageSrv.get('myProfile', 'session');
  const _orgStatus = _sessionData?.org?.status;
  const _tccExpiryDate = _sessionData?.org?.tccExpiryDate

  const isDateExpired = (dateString:any) =>{
    const givenDate = new Date(dateString);
    const today = new Date();
    return givenDate < today;
  }
  const isTCCExpired = _tccExpiryDate ? isDateExpired(_tccExpiryDate) : false;
  console.log("tioi",_tccExpiryDate, isTCCExpired, isDateExpired(_tccExpiryDate))
  const _renderElseBody = () => {
    if (isTCCExpired) { // Check if TCC is expired
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.tccExpired || {})}
        />
      );
    } 
  };

  return (
    <div>
      {_renderHeader()}
      {isTCCExpired ? _renderElseBody() : _renderPage()}
      {_renderPagination()}
      {_renderErrorModals()}
      {_renderNotifications()}
    </div>
  );
};
